<div>
  <app-segment-control #segmentControl (segmentIndexChange)="segmentIndexChanged($event)" [style]="SegmentStyle.Secondary">
    <app-segment-control-item text="Support Contacts" [active]="true"></app-segment-control-item>
    <app-segment-control-item text="Support Information"></app-segment-control-item>
    <app-segment-control-item text="Support Links"></app-segment-control-item>
  </app-segment-control>

  <div>
    @if (currentSegment === 0) {
      <app-trial-support-contacts #contactsComponent (hasChanged)="contactsHasChanges.emit($event)" [trial]="trial"></app-trial-support-contacts>
    }

    @if (currentSegment === 1) {
      <app-trial-support-info #supportInfo (hasChanged)="contactsHasChanges.emit($event)" [trial]="trial"></app-trial-support-info>
    }

    @if (currentSegment === 2) {
      <app-trial-support-links #linksComponent [trial]="trial"></app-trial-support-links>
    }
  </div>
</div>

<app-modal #unsavedModal>
  <div class="modal-header">
    <h2 class="modal-title">Unsaved Changes</h2>
  </div>
  <div class="modal-body">
    <p>You have unsaved changes, are you sure you want to continue and lose your changes?</p>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="onCancelSegmentSwitch()" class="btn btn-secondary">No, go back</a>
      </div>
      <div class="col-6">
        <a (click)="onConfirmSegmentSwitch()" class="btn btn-primary">Yes, continue</a>
      </div>
    </div>
  </div>
</app-modal>
